import React from 'react'
import { Parallax } from 'react-scroll-parallax'
import Scrollchor from 'react-scrollchor'

const Video = () =>
    <div className="para-contain u-z--1">
        {/* <Parallax
            className="para-contain__bg"
            y={[0, -50]}
            tagOuter="figure"
            disabled={true}
            // disabled={window.innerWidth < 768}
        >
            <div className="dividerline u-z-1 u-t-15"></div>
        </Parallax> */}
        <Parallax
            className="para-contain__over"
            // y={[100, -100]}
            y={[50, -30]}
            tagOuter="figure"
            disabled={true}
            // disabled={window.innerWidth < 768}
        >
            <div className="container-fluid p-0">
                <div className="row no-gutters">
                    <div className="col-12">
                        <div className="video" id="watchnow">
                            <iframe
                                id="ytplayer"
                                width="100%"
                                height="100%"
                                src="https://www.youtube.com/embed/4fCQ4drZkOE?controls=0&enablejsapi=1"
                                frameBorder="0"
                                allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                                allowFullScreen
                            ></iframe>
                        </div>
                        <Scrollchor
                            className="anchor preorder"
                            to="#bundles"
                            disableHistory={true}
                        >
                            <div onClick={() => {
                                if (window.s_gi && window.s_dtm) {
                                    let s = s_gi('wmg,wmggbglobal,wmgprl,wmgprlgb,wmgkanomusic.com')
                                    s_dtm.linkTrackVars='prop1,eVar4'
                                    s_dtm.prop1 = 'Kano'
                                    s_dtm.eVar4 = 'Kano'
                                    s_dtm.tl(this, 'o', 'Kano:Hoodies All Summer Pre-order:Landing:Pre-order Navigation Click')
                                }
                            }}>
                                {/* <img className="preorder__text" src="img/preorder.png" alt="Pre-Order"  /><br /> */}
                                <div className="preorder__text">Order</div>
                                <img className="preorder__arrow" src="img/downarrow.png" alt="Down arrow" />
                            </div>
                        </Scrollchor>
                    </div>
                </div>
            </div>
        </Parallax>
    </div>

export default Video
